import * as React from 'react';
import { StaticImage } from 'gatsby-plugin-image';
import Layout from '../../components/Layout/index';
import HeroBanner from '../../components/HeroBanner';
import CTABanner from '../../components/CTABanner';
import Button from '../../components/Button';

import ChartSection from './components/ChartSection';
import ProgramFindingsSection from './components/ProgramFindingsSection';
import ImprovementProgramInfoGraphicsSection from './components/ImprovementProgramInfoGraphicsSection';
import RootCauseSection from './components/RootCauseSection';
import CaseStudiesSection from './components/CaseStudiesSection';
import ForumsSection from './components/ForumsSection';

import './style.scss';
import SplitContent from '../../components/SplitContent';

const WorkAndAchievementsPage = () => {
  return (
    <Layout pageTitle="Councils' Work and Activities">
      <HeroBanner
        title="Councils' Work and Activities 2021/22"
        photo={
          <StaticImage
            className="shape shape-photo"
            src="./assets/hero.png"
            layout="fixed"
            alt="Rachel Webber, WA member of the Professional Standards Councils"
            quality={100}
          />
        }
      >
        <p>
          As of 30 June 2022, there were 18 schemes in force nationally. The number of occupational association
          members subject to these schemes has increased from over 86,000 to over 93,000.
        </p>

        <Button
          color="primary"
          label="Read more about this chapter"
          icon="link"
          annualReportPage={33}
          onClick={() => window.gtag('event', 'Councils’ Work Read More')}
        />
      </HeroBanner>

      <ChartSection />
      <ProgramFindingsSection />
      <ImprovementProgramInfoGraphicsSection />
      <RootCauseSection />
      <CaseStudiesSection />
      <ForumsSection />

      <section className="report">
        <div className="container">
          <h2 className="section-title">
            A clearer, simpler, and more efficient Scheme Application Framework
          </h2>

          <SplitContent
            image={
              <StaticImage
                layout="fullWidth"
                className="shape shape-photo"
                src="./assets/report.png"
                alt="Close up image showing a hand holding a pair of glasses and notebook"
              />
            }
            isReversed
          >
            <p>
              Released in June 2022, the new Scheme Application Framework was developed in response to association
              feedback regarding the previous Application Guidelines and Template, which occupational associations found
              overly technical, cumbersome, and difficult to follow.
            </p>

            <Button label="Learn more" icon="link" color="primary" annualReportPage={18} />
          </SplitContent>
        </div>
      </section>

      <CTABanner
        annualReportPage={29}
        cover={
          <StaticImage
            src="./assets/pdf-cover-02.png"
            alt="Cover of Professional Standards Councils' 2021/22 Annual Report Councils' Work and Activities Chapter"
            width={460}
          />
        }
      />
    </Layout>
  );
};

export default WorkAndAchievementsPage;
